/**
 * Camadas cuja cor sai de um hash do valor de um campo, e não de classes fixas.
 *
 * A legenda delas não pode ser escrita à mão: as classes só são conhecidas
 * depois de ler quais valores a camada de fato tem. Cada entrada aqui diz qual
 * campo o `useCategoricalLegend` deve consultar via WFS.
 */
export const APL_LAYER_NAME = "apl_pe_observatorio";
export const VOCACAO_LAYER_NAME = "municipios_pe_adepe";

export const CATEGORICAL_LEGEND_FIELDS: Record<string, string> = {
  [APL_LAYER_NAME]: "apls",
  [VOCACAO_LAYER_NAME]: "vocacao_1",
};
